import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import PrivateRoute from './PrivateRoute';
import Login from '../pages/auth/Login';
import Profile from '../pages/auth/Profile';
import Dashboard from '../pages/dashboard/Dashboard';

// Attendance Module
import AttendanceList from '../pages/attendance/AttendanceList';
import AttendanceCreate from '../pages/attendance/AttendanceCreate';

// SuperAdmin Pages
import SchoolsList from '../pages/superadmin/SchoolsList';
import CreateSchool from '../pages/superadmin/CreateSchool';
import EditSchool from '../pages/superadmin/EditSchool';
import SchoolDetail from '../pages/superadmin/SchoolDetail';
import ModuleAssignmentPage from '../pages/superadmin/ModuleAssignmentPage';

// Admin Pages
import SystemSettings from '../pages/admin/SystemSettings';
import StudentsList from '../pages/admin/StudentsList';
import StaffList from '../pages/admin/StaffList';

// Enquiry Module
import EnquiryList from '../pages/enquiry/EnquiryList';

// Fees Module
import FeesModuleHome from '../modules/fees/pages/FeesModuleHome';
import FeeDepositPage from '../modules/fees/pages/FeeDepositPage';
import BulkFeeCollectionPage from '../modules/fees/pages/BulkFeeCollectionPage';
import ChequeReconciliationPage from '../modules/fees/pages/ChequeReconciliationPage';
import FeeReceiptManagementPage from '../modules/fees/pages/FeeReceiptManagementPage';
import FeeDiscountManagementPage from '../modules/fees/pages/FeeDiscountManagementPage';
import FeeRefundManagementPage from '../modules/fees/pages/FeeRefundManagementPage';
import FeeLedgerReportsPage from '../modules/fees/ledger/FeeLedgerReportsPage';
import NoDuesCertificatePage from '../modules/fees/pages/NoDuesCertificatePage';
import DaybookReceiptPage from '../modules/fees/pages/DaybookReceiptPage';

// Examination Module
import ExaminationList from '../pages/examination/ExaminationList';
import ExaminationCreate from '../pages/examination/ExaminationCreate';
import ExaminationManage from '../pages/examination/ExaminationManage';
import MarksEntry from '../pages/examination/MarksEntry';

// Homework Module
import HomeworkList from '../pages/homework/HomeworkList';

// Library Module
import LibraryList from '../pages/library/LibraryList';

// Transportation Module
import TransportationList from '../pages/transportation/TransportationList';

// Hostel Module
import HostelList from '../pages/hostel/HostelList';

// Stock Module
import StockList from '../pages/stock/StockList';

// Accounts Module
import AccountsList from '../pages/accounts/AccountsList';

// Messaging Module
import MessagingList from '../pages/messaging/MessagingList';

// Visitors Module
import VisitorsList from '../pages/visitors/VisitorsList';

// Tasks Module
import TasksList from '../pages/tasks/TasksList';

// Identity Cards Module
import IdentityCardsList from '../pages/identity-cards/IdentityCardsList';

// Media Module
import MediaList from '../pages/media/MediaList';

// Certificates Module
import CertificatesList from '../pages/certificates/CertificatesList';

// Reports Module
import ReportsList from '../pages/reports/ReportsList';

// Report Settings Pages
import ReportSettingsPage from '../pages/system-settings/report-settings/ReportSettingsPage';

// User Management Pages
import RolesList from '../pages/user-management/RolesList';
import RoleForm from '../pages/user-management/RoleForm';
import UsersList from '../pages/user-management/UsersList';
import UserForm from '../pages/user-management/UserForm';
import BulkUserUpload from '../pages/user-management/BulkUserUpload';
import UserLogList from '../pages/user-management/UserLogList';
import ReceiptEditLogList from '../pages/user-management/ReceiptEditLogList';
import StudentCreate from '../modules/scholar-register/students/StudentCreate';
import StudentEdit from '../modules/scholar-register/students/StudentEdit';
import StudentProfile from '../modules/scholar-register/students/StudentProfile';
import SessionRecordList from '../modules/scholar-register/session-record/SessionRecordList';
import SessionRecordEdit from '../modules/scholar-register/session-record/SessionRecordEdit';
import SessionTransferPage from '../modules/scholar-register/session-transfer/SessionTransferPage';
import SubjectAssignSubjectWise from '../modules/scholar-register/subject-assign-subjectwise/SubjectAssignSubjectWise';
import StudentPerformancePage from '../modules/scholar-register/student-performance/StudentPerformance';
import LogsIndex from '../pages/system-settings/logs/LogsIndex';
import UserLogs from '../pages/system-settings/logs/UserLogs';
import AuditLogs from '../pages/system-settings/logs/AuditLogs';
import CommunicationSettings from '../pages/system-settings/communication/CommunicationSettings';
import PaymentSettingsLayout from '../pages/system-settings/payments/PaymentSettingsLayout';
import ScholarRegisterLayout from '../modules/scholar-register/layout/ScholarRegisterLayout';
import StudentList from '../modules/scholar-register/students/StudentList';
import ScholarDashboard from '../modules/scholar-register/dashboard/Dashboard';
import GrievanceList from '../modules/scholar-register/grievance/GrievanceList';
import GrievanceCreate from '../modules/scholar-register/grievance/GrievanceCreate';
import GrievanceView from '../modules/scholar-register/grievance/GrievanceView';
import GrievanceEdit from '../modules/scholar-register/grievance/GrievanceEdit';
import StudentComplaintsList from '../modules/scholar-register/student-complaints/StudentComplaintsList';
import StudentComplaintView from '../modules/scholar-register/student-complaints/StudentComplaintView';
import StudentComplaintEdit from '../modules/scholar-register/student-complaints/StudentComplaintEdit';
import UnderConstruction from '../components/common/UnderConstruction';
import StudentStatusList from '../modules/scholar-register/student-status/StudentStatusList';
import RteStudentsList from '../modules/scholar-register/rte/RteStudentsList';
import BPLStudentsList from '../modules/scholar-register/bpl-students/BPLStudentsList';
import BPLStudentView from '../modules/scholar-register/bpl-students/BPLStudentView';
import ReStudyList from '../modules/scholar-register/re-study/ReStudyList';
import StudentBranchLinkPage from '../modules/scholar-register/student-branch-link/StudentBranchLinkPage';
import StudentSubjectPage from '../modules/scholar-register/student-subject/StudentSubjectPage';
import HouseAssignPage from '../modules/scholar-register/student-house/HouseAssignPage';
import StudentLogPage from '../modules/scholar-register/student-log/StudentLogPage';
import ReportsPage from '../modules/scholar-register/reports/ReportsPage';
import CertificatesPage from '../modules/scholar-register/certificates/CertificatesPage';
import StudentIdCardPage from '../modules/scholar-register/certificates/id-card/StudentIdCardPage';
import StudentTrackHistoryPage from '../modules/scholar-register/student-track-history/StudentTrackHistoryPage';
import GatePassPage from '../modules/scholar-register/gate-pass/GatePassPage';
import SystemSettingsLayout from '../components/layout/SystemSettingsLayout';
import MainLayout from '../components/layout/MainLayout';
import SmsSettings from '../pages/system-settings/communication/sms/SmsSettings';
import SmsTemplates from '../pages/system-settings/communication/sms/SmsTemplates';
import EmailConfig from '../pages/system-settings/communication/email/EmailConfig';
import EmailTemplates from '../pages/system-settings/communication/email/EmailTemplates';
import WhatsappConfig from '../pages/system-settings/communication/whatsapp/WhatsappConfig';
import WhatsappTemplates from '../pages/system-settings/communication/whatsapp/WhatsappTemplates';
import PaymentGatewaySettings from '../pages/system-settings/payments/PaymentGatewaySettings';
import PosSettings from '../pages/system-settings/payments/PosSettings';
import PaymentGatewayReports from '../pages/system-settings/payments/PaymentGatewayReports';
import PosPaymentReports from '../pages/system-settings/payments/PosPaymentReports';

/**
 * Application Router
 * Defines all routes and handles authentication
 */
const AppRouter: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/login"
        element={
          isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
        }
      />

      {/* Private Routes */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />

      {/* SuperAdmin Routes (GLOBAL scope) */}
      <Route
        path="/superadmin/schools"
        element={
          <PrivateRoute requiredRoles={['SUPER_ADMIN']}>
            <SchoolsList />
          </PrivateRoute>
        }
      />
      <Route
        path="/superadmin/schools/create"
        element={
          <PrivateRoute requiredRoles={['SUPER_ADMIN']}>
            <CreateSchool />
          </PrivateRoute>
        }
      />
      <Route
        path="/superadmin/schools/:id"
        element={
          <PrivateRoute requiredRoles={['SUPER_ADMIN']}>
            <SchoolDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/superadmin/schools/:id/edit"
        element={
          <PrivateRoute requiredRoles={['SUPER_ADMIN']}>
            <EditSchool />
          </PrivateRoute>
        }
      />

      <Route
        path="/modules"
        element={
          <PrivateRoute requiredRoles={['SUPER_ADMIN']}>
            <ModuleAssignmentPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/superadmin/communication-settings"
        element={
          <PrivateRoute requiredRoles={['SUPER_ADMIN']}>
            <MainLayout>
              <CommunicationSettings />
            </MainLayout>
          </PrivateRoute>
        }
      />

      {/* Admin Routes (SCHOOL scope) */}
      <Route
        path="/system-settings"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_SETTINGS_VIEW']}>
            <SystemSettings />
          </PrivateRoute>
        }
      />
      {/* Nested System Settings routes to ensure consistent layout and navigation */}
      <Route
        path="/system-settings"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_SETTINGS_VIEW']}>
            <SystemSettingsLayout />
          </PrivateRoute>
        }
      >
        {/* Communication Settings */}
        <Route
          path="communication"
          element={
            <PrivateRoute requiredPermissions={['COMMUNICATION_SETTINGS_VIEW']}>
              <CommunicationSettings />
            </PrivateRoute>
          }
        />
        <Route
          path="communication/sms-config"
          element={
            <PrivateRoute requiredPermissions={['COMMUNICATION_SETTINGS_SCHOOL_OVERRIDE']}>
              <SmsSettings />
            </PrivateRoute>
          }
        />
        <Route
          path="communication/sms-templates"
          element={
            <PrivateRoute requiredPermissions={['COMMUNICATION_SETTINGS_SCHOOL_OVERRIDE']}>
              <SmsTemplates />
            </PrivateRoute>
          }
        />
        <Route
          path="communication/email-config"
          element={
            <PrivateRoute requiredPermissions={['COMMUNICATION_SETTINGS_SCHOOL_OVERRIDE']}>
              <EmailConfig />
            </PrivateRoute>
          }
        />
        <Route
          path="communication/email-templates"
          element={
            <PrivateRoute requiredPermissions={['COMMUNICATION_SETTINGS_SCHOOL_OVERRIDE']}>
              <EmailTemplates />
            </PrivateRoute>
          }
        />
        <Route
          path="communication/whatsapp-config"
          element={
            <PrivateRoute requiredPermissions={['COMMUNICATION_SETTINGS_SCHOOL_OVERRIDE']}>
              <WhatsappConfig />
            </PrivateRoute>
          }
        />
        <Route
          path="communication/whatsapp-templates"
          element={
            <PrivateRoute requiredPermissions={['COMMUNICATION_SETTINGS_SCHOOL_OVERRIDE']}>
              <WhatsappTemplates />
            </PrivateRoute>
          }
        />

        {/* Payment Settings */}
        <Route
          path="payments"
          element={
            <PrivateRoute requiredPermissions={['PAYMENT_SETTINGS_VIEW']}>
              <PaymentSettingsLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="gateway-config" replace />} />
          <Route
            path="gateway-config"
            element={
              <PrivateRoute requiredPermissions={['PAYMENT_SETTINGS_MANAGE']}>
                <PaymentGatewaySettings />
              </PrivateRoute>
            }
          />
          <Route
            path="pos-config"
            element={
              <PrivateRoute requiredPermissions={['PAYMENT_SETTINGS_MANAGE']}>
                <PosSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="gateway-reports"
            element={
              <PrivateRoute requiredPermissions={['PAYMENT_SETTINGS_VIEW']}>
                <PaymentGatewayReports />
              </PrivateRoute>
            }
          />
          <Route
            path="pos-reports"
            element={
              <PrivateRoute requiredPermissions={['PAYMENT_SETTINGS_VIEW']}>
                <PosPaymentReports />
              </PrivateRoute>
            }
          />
        </Route>
      </Route>
      <Route
        path="/report-settings/:type"
        element={
          <PrivateRoute>
            <ReportSettingsPage />
          </PrivateRoute>
        }
      />
      {/* Scholar Register Module */}
      <Route
        path="/scholar-register"
        element={
          <PrivateRoute requiredPermissions={['SCHOLAR_REGISTER_VIEW']}>
            <ScholarRegisterLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route
          path="dashboard"
          element={
            <PrivateRoute requiredPermissions={['SCHOLAR_DASHBOARD_VIEW']}>
              <ScholarDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="students"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_VIEW']}>
              <StudentList />
            </PrivateRoute>
          }
        />
        <Route
          path="students/create"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_CREATE']}>
              <StudentCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="students/edit/:id"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_EDIT']}>
              <StudentEdit />
            </PrivateRoute>
          }
        />
        <Route
          path="students/:id"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_VIEW']}>
              <StudentProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="session-record"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_VIEW']}>
              <SessionRecordList />
            </PrivateRoute>
          }
        />
        <Route
          path="session-record/:id/edit"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_EDIT']}>
              <SessionRecordEdit />
            </PrivateRoute>
          }
        />
        <Route
          path="session-transfer"
          element={
            <PrivateRoute requiredPermissions={['SESSION_TRANSFER_VIEW']}>
              <SessionTransferPage />
            </PrivateRoute>
          }
        />
        <Route
          path="subject-assign-subjectwise"
          element={
            <PrivateRoute requiredPermissions={['SUBJECT_ASSIGN_VIEW']}>
              <SubjectAssignSubjectWise />
            </PrivateRoute>
          }
        />
        <Route
          path="performance"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_PERFORMANCE_VIEW']}>
              <StudentPerformancePage />
            </PrivateRoute>
          }
        />
        <Route
          path="grievance"
          element={
            <PrivateRoute requiredPermissions={['GRIEVANCE_VIEW']}>
              <GrievanceList />
            </PrivateRoute>
          }
        />
        <Route
          path="grievance/create"
          element={
            <PrivateRoute requiredPermissions={['GRIEVANCE_MANAGE']}>
              <GrievanceCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="grievance/:id"
          element={
            <PrivateRoute requiredPermissions={['GRIEVANCE_VIEW']}>
              <GrievanceView />
            </PrivateRoute>
          }
        />
        <Route
          path="grievance/:id/edit"
          element={
            <PrivateRoute requiredPermissions={['GRIEVANCE_MANAGE']}>
              <GrievanceEdit />
            </PrivateRoute>
          }
        />
        <Route
          path="complaints"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_COMPLAINT_VIEW']}>
              <StudentComplaintsList />
            </PrivateRoute>
          }
        />
        <Route
          path="complaints/:id"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_COMPLAINT_VIEW']}>
              <StudentComplaintView />
            </PrivateRoute>
          }
        />
        <Route
          path="complaints/:id/edit"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_COMPLAINT_MANAGE']}>
              <StudentComplaintEdit />
            </PrivateRoute>
          }
        />
        <Route
          path="rte"
          element={
            <PrivateRoute requiredPermissions={['RTE_STUDENTS_VIEW']}>
              <RteStudentsList />
            </PrivateRoute>
          }
        />
        <Route
          path="bpl"
          element={
            <PrivateRoute requiredPermissions={['BPL_STUDENT_VIEW']}>
              <BPLStudentsList />
            </PrivateRoute>
          }
        />
        <Route
          path="bpl-students/:id"
          element={
            <PrivateRoute requiredPermissions={['BPL_STUDENT_VIEW']}>
              <BPLStudentView />
            </PrivateRoute>
          }
        />
        <Route
          path="status"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_STATUS_VIEW']}>
              <StudentStatusList />
            </PrivateRoute>
          }
        />
        <Route
          path="re-study"
          element={
            <PrivateRoute requiredPermissions={['RE_STUDY_VIEW']}>
              <ReStudyList />
            </PrivateRoute>
          }
        />
        <Route path="transfer" element={<UnderConstruction title="Session Transfer" />} />
        <Route path="subject-assign-subject" element={<UnderConstruction title="Subject Assign (Subject wise)" />} />
        <Route
          path="subject-assign-student"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_SUBJECT_VIEW']}>
              <StudentSubjectPage />
            </PrivateRoute>
          }
        />
        <Route
          path="branch-link"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_BRANCH_LINK_VIEW']}>
              <StudentBranchLinkPage />
            </PrivateRoute>
          }
        />
        <Route
          path="house-assign"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_HOUSE_VIEW']}>
              <HouseAssignPage />
            </PrivateRoute>
          }
        />
        <Route
          path="logs"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_LOG_VIEW']}>
              <StudentLogPage />
            </PrivateRoute>
          }
        />
        <Route
          path="reports"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_REPORT_VIEW']}>
              <ReportsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="certificates"
          element={
            <PrivateRoute requiredPermissions={['CERTIFICATE_VIEW']}>
              <CertificatesPage />
            </PrivateRoute>
          }
        />
        <Route
          path="certificates/id-cards"
          element={
            <PrivateRoute requiredPermissions={['ID_CARD_VIEW']}>
              <StudentIdCardPage />
            </PrivateRoute>
          }
        />
        <Route
          path="gate-pass"
          element={
            <PrivateRoute requiredPermissions={['GATE_PASS_VIEW']}>
              <GatePassPage />
            </PrivateRoute>
          }
        />
        <Route
          path="track-history"
          element={
            <PrivateRoute requiredPermissions={['STUDENT_TRACK_HISTORY_VIEW']}>
              <StudentTrackHistoryPage />
            </PrivateRoute>
          }
        />
      </Route>
      <Route
        path="/staff"
        element={
          <PrivateRoute>
            <StaffList />
          </PrivateRoute>
        }
      />

      {/* Attendance Module (SCHOOL scope) */}
      <Route
        path="/attendance"
        element={
          <PrivateRoute>
            <AttendanceList />
          </PrivateRoute>
        }
      />
      <Route
        path="/attendance/create"
        element={
          <PrivateRoute requiredPermissions={['ATTENDANCE_MARK']}>
            <AttendanceCreate />
          </PrivateRoute>
        }
      />

      {/* Enquiry Module (SCHOOL scope) */}
      <Route
        path="/enquiry"
        element={
          <PrivateRoute>
            <EnquiryList />
          </PrivateRoute>
        }
      />

      {/* Fee Module (SCHOOL scope) */}
      <Route
        path="/fees"
        element={
          <PrivateRoute>
            <FeesModuleHome />
          </PrivateRoute>
        }
      />
      <Route
        path="/fees/deposit"
        element={
          <PrivateRoute requiredPermissions={['FEES_DEPOSIT_VIEW']}>
            <FeeDepositPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/fees/deposit-all"
        element={
          <PrivateRoute requiredPermissions={['FEES_DEPOSIT_ALL_VIEW']}>
            <BulkFeeCollectionPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/fees/cheque-reconciliation"
        element={
          <PrivateRoute requiredPermissions={['FEE_MANAGE']}>
            <ChequeReconciliationPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/fees/view-fee-receipts"
        element={
          <PrivateRoute requiredPermissions={['FEES_VIEW', 'FEE_VIEW']}>
            <FeeReceiptManagementPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/fees/fee-discount"
        element={
          <PrivateRoute requiredPermissions={['FEES_MANAGE', 'FEE_MANAGE']}>
            <FeeDiscountManagementPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/fees/fee-refund"
        element={
          <PrivateRoute requiredPermissions={['FEES_REFUND', 'FEE_MANAGE']}>
            <FeeRefundManagementPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/fees/fees-ledger-reports"
        element={
          <PrivateRoute requiredPermissions={['FEES_LEDGER_VIEW', 'FEES_REPORT', 'FEE_VIEW']}>
            <FeeLedgerReportsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/fees/no-dues-receipt"
        element={
          <PrivateRoute requiredPermissions={['FEES_REPORT', 'FEE_VIEW']}>
            <NoDuesCertificatePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/fees/daybook-receipt"
        element={
          <PrivateRoute requiredPermissions={['FEES_DAYBOOK_VIEW']}>
            <DaybookReceiptPage />
          </PrivateRoute>
        }
      />

      {/* Examination Module (SCHOOL scope) */}
      <Route
        path="/examinations"
        element={
          <PrivateRoute>
            <ExaminationList />
          </PrivateRoute>
        }
      />
      <Route
        path="/examinations/create"
        element={
          <PrivateRoute>
            <ExaminationCreate />
          </PrivateRoute>
        }
      />
      <Route
        path="/examinations/:id/manage"
        element={
          <PrivateRoute>
            <ExaminationManage />
          </PrivateRoute>
        }
      />
      <Route
        path="/examinations/:id/marks"
        element={
          <PrivateRoute>
            <MarksEntry />
          </PrivateRoute>
        }
      />

      {/* Homework Module (SCHOOL scope) */}
      <Route
        path="/homework"
        element={
          <PrivateRoute>
            <HomeworkList />
          </PrivateRoute>
        }
      />

      {/* Library Module (SCHOOL scope) */}
      <Route
        path="/library"
        element={
          <PrivateRoute>
            <LibraryList />
          </PrivateRoute>
        }
      />

      {/* Transportation Module (SCHOOL scope) */}
      <Route
        path="/transportation"
        element={
          <PrivateRoute>
            <TransportationList />
          </PrivateRoute>
        }
      />

      {/* Hostel Module (SCHOOL scope) */}
      <Route
        path="/hostel"
        element={
          <PrivateRoute>
            <HostelList />
          </PrivateRoute>
        }
      />

      {/* Stock Module (SCHOOL scope) */}
      <Route
        path="/stock"
        element={
          <PrivateRoute>
            <StockList />
          </PrivateRoute>
        }
      />

      {/* Accounts Module (SCHOOL scope) */}
      <Route
        path="/accounts"
        element={
          <PrivateRoute>
            <AccountsList />
          </PrivateRoute>
        }
      />

      {/* Messaging Module (SCHOOL scope) */}
      <Route
        path="/messaging"
        element={
          <PrivateRoute>
            <MessagingList />
          </PrivateRoute>
        }
      />

      {/* Visitors Module (SCHOOL scope) */}
      <Route
        path="/visitors"
        element={
          <PrivateRoute>
            <VisitorsList />
          </PrivateRoute>
        }
      />

      {/* Tasks Module (SCHOOL scope) */}
      <Route
        path="/tasks"
        element={
          <PrivateRoute>
            <TasksList />
          </PrivateRoute>
        }
      />

      {/* Identity Cards Module (SCHOOL scope) */}
      <Route
        path="/identity-cards"
        element={
          <PrivateRoute>
            <IdentityCardsList />
          </PrivateRoute>
        }
      />

      {/* Media Module (SCHOOL scope) */}
      <Route
        path="/media"
        element={
          <PrivateRoute>
            <MediaList />
          </PrivateRoute>
        }
      />

      {/* Certificates Module (SCHOOL scope) */}
      <Route
        path="/certificates"
        element={
          <PrivateRoute>
            <CertificatesList />
          </PrivateRoute>
        }
      />

      {/* Reports Module (SCHOOL scope) */}
      <Route
        path="/reports"
        element={
          <PrivateRoute>
            <ReportsList />
          </PrivateRoute>
        }
      />

      {/* User Management Module (Nested in System Settings) */}
      <Route
        path="/system-settings/user-roles"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_SETTINGS_VIEW']}>
            <SystemSettings defaultExpanded="user-roles" />
          </PrivateRoute>
        }
      />
      <Route
        path="/system-settings/user-roles/roles"
        element={
          <PrivateRoute>
            <RolesList />
          </PrivateRoute>
        }
      />
      <Route
        path="/system-settings/user-roles/roles/create"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_ROLE_CREATE']}>
            <RoleForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/system-settings/user-roles/roles/edit/:id"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_ROLE_CREATE']}>
            <RoleForm />
          </PrivateRoute>
        }
      />

      <Route
        path="/system-settings/user-roles/users"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_USER_VIEW']}>
            <UsersList />
          </PrivateRoute>
        }
      />
      <Route
        path="/system-settings/user-roles/users/create"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_USER_CREATE']}>
            <UserForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/system-settings/user-roles/users/edit/:id"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_USER_CREATE']}>
            <UserForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/system-settings/user-roles/bulk-users"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_USER_CREATE']}>
            <BulkUserUpload />
          </PrivateRoute>
        }
      />
      <Route
        path="/system-settings/user-roles/user-logs"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_USER_VIEW']}>
            <UserLogList />
          </PrivateRoute>
        }
      />
      <Route
        path="/system-settings/user-roles/receipt-edit-logs"
        element={
          <PrivateRoute>
            <ReceiptEditLogList />
          </PrivateRoute>
        }
      />

      {/* Deprecated direct mounts retained only if needed; prefer nested routes above */}

      <Route
        path="/system-settings/logs"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_SETTINGS_MANAGE']}>
            <LogsIndex />
          </PrivateRoute>
        }
      />
      <Route
        path="/system-settings/logs/users"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_SETTINGS_MANAGE']}>
            <UserLogs />
          </PrivateRoute>
        }
      />
      <Route
        path="/system-settings/logs/audit"
        element={
          <PrivateRoute requiredPermissions={['SYSTEM_SETTINGS_MANAGE']}>
            <AuditLogs />
          </PrivateRoute>
        }
      />

      {/* Default Route */}
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* 404 - redirect to dashboard or login */}
      <Route
        path="*"
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
};

export default AppRouter;
